import {AddressFieldValue} from "../../../../../components/general/AddressField.tsx";
import {DropdownVATOptions} from "../../../../../types/enums.ts";
import type {PaymentTerm, Unit} from "../../../../../generated/enums.ts";

export type InvoiceCustomer = {
    id: string
    name: string
    email: string
    ccEmail: string
    vatNumber: string
    addressExtraLine: string
    address: AddressFieldValue | null
    defaultPaymentTerm: PaymentTerm | null
    isAdHoc?: boolean
    isNew?: boolean
}

export type InvoiceLineItem = {
    id: string
    description: string
    quantity: number | null
    unit: Unit
    unitPrice: number | null
    vat: DropdownVATOptions
    catalogueItemId: string | null
    saveToCatalogue: boolean
    serviceStartDate?: string | null
    serviceEndDate?: string | null
}

export const EMPTY_ADDRESS: AddressFieldValue = {
    street_name: '',
    house_number: '',
    city_name: '',
    postal_code: '',
    country: 'NL',
}

export const vatOptions = [
    {value: DropdownVATOptions.STANDARD, label: "21%"},
    {value: DropdownVATOptions.REDUCED, label: "9%"},
    {value: DropdownVATOptions.EXEMPT, label: "Vrijgesteld"},
    {value: DropdownVATOptions.REVERSE_CHARGE, label: "Verlegd"},
    {value: DropdownVATOptions.ZERO, label: "0%"},
]

export const vatOptionLabel = (vat: DropdownVATOptions): string =>
    vatOptions.find(opt => opt.value === vat)?.label ?? String(vat)

export const paymentTermOptions: Array<{ value: PaymentTerm, label: string }> = [
    {value: 14, label: "14 dagen"},
    {value: 15, label: "15 dagen"},
    {value: 30, label: "30 dagen"},
    {value: 60, label: "60 dagen"},
    {value: 90, label: "90 dagen"},
]

export const unitOptions: Array<{ value: Unit, label: string }> = [
    {value: 'piece', label: "stuks"},
    {value: 'hour', label: "uur"},
    {value: 'day', label: "dag"},
    {value: 'project', label: "project"},
    {value: 'month', label: "maand"},
    {value: 'km', label: "km"},
]

export const unitOptionLabel = (unit: Unit): string =>
    unitOptions.find(opt => opt.value === unit)?.label ?? String(unit)

export const DEFAULT_LINE_UNIT: Unit = 'piece'

export const DEFAULT_INVOICE_NUMBER_PREFIX = 'INV'

export const MAX_INVOICE_NUMBER_PREFIX_LENGTH = 10
